var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fade-transition',{attrs:{"mode":'out-in'}},[_c(_vm.template,{tag:"component"},[_c('router-view')],1)],1),_vm._v(" "),_c('ConfirmNavigationModal',{attrs:{"show-modal":_vm.showConfirmNavigationModal},on:{"leave":_vm.nextFn,"stay":_vm.stayFn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }